export default {
  state: {
    gallery: [],
    currentGallery: null,

  },
  mutations: {
    setGallery(state, payload) {
      state.gallery = payload;
    },
    setCurrentGallery(state, payload) {
      state.currentGallery = payload;
    },

  },
  actions: {

    setGallery: async ({
      commit
    }, payload) => {
      commit('setGallery', payload);
    },
    setCurrentGallery: ({
      commit
    }, payload) => {
      commit('setCurrentGallery', payload);
    },
  },
  getters: {

    getGallery(state) {
      return state.gallery;
    },
    getCurrentGallery(state) {
      return state.currentGallery;
    },

  }
}
